import React, { useEffect, useState } from 'react';
import { AonDialog } from '../../../components/core/AonDialog';
import { AonLink, LINK_TYPE } from '../../../components/core/AonLink';
import { AonButton } from '../../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../../components/core/AonButton/consts';
import { UuiLogo, UuiSpinner } from '@aonunited/react';
import { useNavigate } from 'react-router-dom';
import { useAppInfoStore } from '../../../store';
import "./aboutus.scss";
import { getApplicationConfig } from '../../../constants/utilities';
export default function Aboutus(props) {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState({
        ApiVersion: "",
        "Copyright": "",
        "IEContactID": 0
    }), pageInfo = _b[0], setPageInfo = _b[1];
    var appConfig = getApplicationConfig();
    var appInfoStore = useAppInfoStore();
    //This useEffect is used for get About us info
    useEffect(function () {
        var _a = appInfoStore.getAppINfo(), apiVersion = _a.apiVersion, Copyright = _a.Copyright, IEContactID = _a.IEContactID;
        setPageInfo({
            ApiVersion: apiVersion || "",
            "Copyright": Copyright || "",
            "IEContactID": IEContactID || 0
        });
    }, []);
    //About us Body
    var AboutBody = function () {
        return React.createElement("div", { className: 'about_body' },
            React.createElement("h3", null, appConfig.applicationName),
            React.createElement("div", { className: 'about-body' }, isLoading ? React.createElement(UuiSpinner, { className: 'about-body-loader', variant: "small" }) :
                React.createElement("div", null,
                    React.createElement("span", null, pageInfo.ApiVersion),
                    React.createElement("p", { style: { marginTop: "40px" } }, pageInfo.Copyright),
                    React.createElement("p", null, window.location.hostname))),
            React.createElement(AonLink, { type: LINK_TYPE.SMALL, to: 'mailto:AonSupport@aon.com' }, "Aon Support"));
    };
    //About us Footer
    var AboutFooter = function () {
        return React.createElement("div", null,
            React.createElement(AonButton, { variant: BUTTON_VARIANT.DEFAULT, onClick: props.onClickClose }, "Close"));
    };
    var handelNavigation = function () {
        var navigate = useNavigate();
        navigate("/");
    };
    return (React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'logo_about_dialog' },
            React.createElement(UuiLogo, { onClick: handelNavigation })), body: React.createElement(AboutBody, null), footer: React.createElement(AboutFooter, null) }));
}
